// src/App.js
import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Login from "./components/Login.js";
import axios from "axios";
import OnboardingForm from "./components/OnboardingForm.js";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "./helper/firebase.js";
import "./App.css"; // Keep your global styles
import Dashboard from "./components/Dashboard.js";
import Header from "./components/Header.js";
import { FAQProvider } from "./context/FAQContext";

function App() {
  const [user, setUser] = useState(null);
  const [dj, setDj] = useState(null); 
  const [loading, setLoading] = useState(true);
  const [uid, setUid] = useState(null);
  const [showDashboard, setShowDashboard] = useState(false);
  const [registrationChecked, setRegistrationChecked] = useState(false);
  // Election status of the DJ's current election, reported up by Dashboard (which
  // owns the elections fetch) so the Header can gate buttons on funnel position.
  const [electionStatus, setElectionStatus] = useState(null);
  const [referralCodeRef, setReferralCodeRef] = useState(React.createRef());

  useEffect(() => { 
    const params = new URLSearchParams(window.location.search);
    const referralCode = params.get('ref');
    setReferralCodeRef(referralCode);
  },[]);

  useEffect(() => {
    console.log("Environment:", process.env.REACT_APP_API_BASE_URL);
    // Listen for authentication state changes
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      setUser(currentUser);
      if (currentUser) {
        const userUid = currentUser.uid;
        setUid(userUid);
        if (userUid){
          try {
            console.log('URL:', `${process.env.REACT_APP_API_BASE_URL}/api/checkUserExist?uid=${userUid}`);
            let res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/checkUserExist?uid=${userUid}`);
            let dj = res.data;
            setDj(dj);
            setShowDashboard(true);
          } catch (error) {
            //redirect to onboarding form
            console.log('User not found in QB',error);
            setShowDashboard(false);
          }
        }
        setRegistrationChecked(true);
        console.log('User logged in with UID:', userUid);
      } else {
        setUid(null);
        setShowDashboard(false); // Reset dashboard view on logout
        setRegistrationChecked(false);
        console.log('User logged out');
      }
      setLoading(false);
    });

    // Cleanup subscription on unmount
    return () => unsubscribe();
  }, []);

  if (loading || (uid && !registrationChecked)) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="flex flex-col items-center gap-4">
          <div className="w-10 h-10 border-4 border-primary border-t-transparent rounded-full animate-spin"></div>
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <FAQProvider>
      <Router>
        <Routes>
          {!user ? (
            <>
              <Route path="/register" element={<Login />} />
              <Route path="/login" element={<Login />} />
              <Route path="/" element={<Navigate to="/login" replace />} />
            </>
          ) : !showDashboard && registrationChecked ? (
            <Route
              path="*"
              element={
                <div className="flex min-h-screen flex-col items-center justify-center">
                  <OnboardingForm
                    firebase_uid={uid}
                    dj={dj}
                    setDj={setDj}
                    onComplete={async (djData) => {
                      let res;
                      let qb_dj;
                      try {
                        res = await axios.post(
                          `${process.env.REACT_APP_API_BASE_URL}/api/createDJ`,
                          djData
                        );
                        qb_dj = res.data;
                      } catch (error) {
                        console.error("Error creating DJ:", error);
                      }
                      //give points if refereral code is used
                      if (referralCodeRef) {
                        console.log("Referral code:", referralCodeRef);
                        //send to backend to check if it is valid
                        try {
                          res = await axios.post(
                            `${process.env.REACT_APP_API_BASE_URL}/api/applyReferral`,
                            {referralCode: referralCodeRef, dj: qb_dj }
                          );
                          if (res.data) {
                            console.log("Referral bonus applied:", res.data);
                          }
                        } catch (error) {
                          console.error("Error applying referral bonus:", error);
                        }
                      }
                      setShowDashboard(true);
                    }}
                  />
                </div>
              }
            />
          ) : (
            <>
              <Route
                path="*"
                element={
                  <div className="min-h-screen bg-gray-50">
                    <Header dj={dj} electionStatus={electionStatus} />
                    <div className="p-0.5 sm:p-0">
                      <Dashboard uid={uid} dj={dj} setDj={setDj} setElectionStatus={setElectionStatus} />
                    </div>
                  </div>
                }
              />
            </>
          )}
        </Routes>
      </Router>
    </FAQProvider>
  );
}

export default App;
